"use client"

import { createContext, useContext, type ReactNode } from "react"

interface SecondarySidebarContextType {
  secondarySidebar: ReactNode | null
}

const SecondarySidebarContext = createContext<
  SecondarySidebarContextType | undefined
>(undefined)

export const useSecondarySidebar = () => {
  const context = useContext(SecondarySidebarContext)
  if (!context) {
    // Return default value for pages without secondary sidebar
    return { secondarySidebar: null }
  }
  return context
}
